<template>
  <div>
    <table-component
      :model="model"
    />
  </div>
</template>

<script>
import TableComponent from '@/dc-it/components/TableComponent.vue'
import Complexion from '@/dc-it/models/Complexion'

export default {
  name: 'ComplexionsView',
  components: { TableComponent },
  data() {
    return {
      model: Complexion,
    }
  },
}
</script>

<style scoped>

</style>
